import { useMantineTheme } from '@mantine/core';
import type { MRT_Column, MRT_RowData } from 'mantine-react-table';
import { useState } from 'react';
import { ControlledInputs } from '../../utils/read-only-inputs/controlledInputs';

export const MantineTableRangeFilter = <T extends MRT_RowData>({
    column,
    rangeFilterIndex,
}: {
    column: MRT_Column<T>;
    rangeFilterIndex?: number;
}) => {
    const theme = useMantineTheme();

    const [minFilter, setMinFilter] = useState<string | null>(null);
    const [maxFilter, setMaxFilter] = useState<string | null>(null);

    const onMinChange = (newMinFilter: string | null) => {
        setMinFilter(newMinFilter === '' ? null : newMinFilter);

        const prevFilterValue = column.getFilterValue() as
            | [string, string]
            | undefined;
        const prevMaxFilter = prevFilterValue?.[1];
        const newMaxFilter = prevMaxFilter ? prevMaxFilter : maxFilter;

        column.setFilterValue([newMinFilter ?? '', newMaxFilter ?? '']);
    };

    const onMaxChange = (newMaxFilter: string | null) => {
        setMaxFilter(newMaxFilter === '' ? null : newMaxFilter);

        const prevFilterValue = column.getFilterValue() as
            | [string, string]
            | undefined;
        const prevMinFilter = prevFilterValue?.[0];
        const newMinFilter = prevMinFilter ? prevMinFilter : minFilter;

        column.setFilterValue([newMinFilter ?? '', newMaxFilter ?? '']);
    };

    return (
        <ControlledInputs.String
            nullable={true}
            value={rangeFilterIndex ? maxFilter : minFilter}
            readOnly={false}
            onChange={rangeFilterIndex ? onMaxChange : onMinChange}
            placeholder={rangeFilterIndex ? 'Max' : 'Min'}
            variant={'unstyled'}
            style={{
                borderBottom: `2px solid ${theme.colors.gray[7]}`,
                fontWeight: 400,
            }}
        />
    );
};
